// 1).cartData  2).searhCartData  3).eventsData  4).hostBenifitsData 5).pages

export const cartData = [
  {
    image: require("../image/imageA.jpg"),
    count: 1,
    name: "Bollywood Blowout",
    Location: "Tilles Center for the Performing Arts",
    date_time: "Sep 22, 2023 - 8:00 AM - 11:00 AM ",
    pris: "$100",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },

  {
    image: require("../image/imageB.jpg"),
    count: 2,
    name: "Vidya Vox Live in Atl",
    Location:
      "15505 N Interstate Hwy 35 building c, Pflugerville, TX 78660, USA ",
    date_time: "Sep 23, 2023 - 2:00 AM - 7:00 AM ",
    pris: "$310",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
  {
    image: require("../image/imageC.jpg"),
    count: 3,
    name: "Austin Garba Culture ",
    Location: "Tilles Center for the Performing Arts",
    date_time: "Sep 25, 2023 - 4:00 AM - 9:00 AM ",
    pris: "$120",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
  {
    image: require("../image/imageC.jpg"),
    count: 4,
    name: "Austin Garba Culture ",
    Location: "Tilles Center for the Performing Arts",
    date_time: "Sep 25, 2023 - 4:00 AM - 9:00 AM ",
    pris: "$120",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
];

export const searchCartData = [
  {
    image: require("../image/imageA.jpg"),
    count: 1,
    name: "Bollywood Blowout",
    Location: "Tilles Center for the Performing Arts",
    date_time: "September 22, 2023 - 8:00 AM - 11:00 AM ",
    pris: "$100",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },

  {
    image: require("../image/imageB.jpg"),
    count: 2,
    name: "Vidya Vox Live in Atl",
    Location:
      "15505 N Interstate Hwy 35 building c, Pflugerville, TX 78660, USA ",
    date_time: "September 23, 2023 - 2:00 AM - 7:00 AM ",
    pris: "$310",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
  {
    image: require("../image/imageC.jpg"),
    count: 3,
    name: "Austin Garba Culture ",
    Location: "Tilles Center for the Performing Arts",
    date_time: "September 25, 2023 - 4:00 AM - 9:00 AM ",
    pris: "$120",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
  {
    image: require("../image/imageC.jpg"),
    count: 4,
    name: "Austin Garba Culture ",
    Location: "Tilles Center for the Performing Arts",
    date_time: "September 25, 2023 - 4:00 AM - 9:00 AM ",
    pris: "$120",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
  {
    image: require("../image/imageA.jpg"),
    count: 5,
    name: "Bollywood Blowout",
    Location: "Tilles Center for the Performing Arts",
    date_time: "September 22, 2023 - 8:00 AM - 11:00 AM ",
    pris: "$100",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
  {
    image: require("../image/imageB.jpg"),
    count: 6,
    name: "Vidya Vox Live in Atl",
    Location:
      "15505 N Interstate Hwy 35 building c, Pflugerville, TX 78660, USA ",
    date_time: "September 23, 2023 - 2:00 AM - 7:00 AM ",
    pris: "$310",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
  {
    image: require("../image/imageA.jpg"),
    count: 7,
    name: "Bollywood Blowout",
    Location: "Tilles Center for the Performing Arts",
    date_time: "September 22, 2023 - 8:00 AM - 11:00 AM ",
    pris: "$100",
    Organized: "Austin Desi Events",
    profileImage: require("../image/boy.png"),
  },
];

export const eventsData = [
  { category: "Cruises", count: 2 },
  { category: "Dance/DJ/Music event", count: 7 },
  { category: "Festivals", count: 11 },
  { category: "Live Music Performances", count: 2 },
  { category: "Music Concerts", count: 1 },
  { category: "Dance/Music event", count: 9 },
];

export const hostBenefitsData = [
  {
    category: "Extra income",
    image: require("../image/icon/income.png"),
    // image: require("../image/icon/banknotes.png"),
    dsc: "We pay you 50% of every ticket's service fees.*",
  },
  {
    category: "Offline payments to hosts",
    image: require("../image/icon/incom.png"),
    dsc: "We handle tickets for the offline/cash payments you directly receive from attendees.",
  },
  {
    category: "Fast payouts",
    image: require("../image/icon/income.png"),
    dsc: "Receive your ticket sales and service fees in 3 days after the event.",
  },
  {
    category: "Flexible payment options",
    image: require("../image/icon/passive-income.png"),
    dsc: "Attendees can purchase tickets using credit/debit card or Zelle.",
  },
  // {
  //   category: "Offline payments to hosts",
  //   image: require("../image/icon/wage.png"),
  //   dsc: "We pay you 50% of every ticket's service fees.*",
  // },
];

export const pages = [
  "Home",
  "Events",
  "About Us",
  "Host Benefits",
  "Create Event",
  "Log In",
  "Sign Up",
];

export const ContactUsMenu = ["Home", "Events", "About Us", "Create Event"];

export const eventDeta = ["September 16, 2023", "September 17, 2023"];
export const eventTime = ["10:00 PM", "10:00 PM"];
export const selectCategory = ["Cruises", "DJ/Dance/Music event", "Festivals"];
export const allPaymentStatus = [
  {
    name: "OnHold",
    displayName: "On Hold",
    id: 1,
    createdBy: 1,
    createdDate: "2023-10-18T06:55:18.63",
    modifiedBy: null,
    modifiedDate: null,
  },
  {
    name: "Confirmed",
    displayName: "Confirmed",
    id: 2,
    createdBy: 1,
    createdDate: "2023-10-18T06:55:27.98",
    modifiedBy: null,
    modifiedDate: null,
  },
  {
    name: "Cancelled",
    displayName: "Cancelled",
    id: 3,
    createdBy: 1,
    createdDate: "2023-10-18T06:55:38.2033333",
    modifiedBy: null,
    modifiedDate: null,
  },
];
